import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Tooltip} from "@mui/material";
import {Link} from "react-router-dom";
import {Cached, PlaylistAdd} from "@mui/icons-material";
import CellShortenedName from "../../../orders/organization/estimate/CellShortenedName";
import selectionTableUtil, {normalizeSelection} from "../../../../../../utils/common/SelectionTableUtil";

const MaterialTable = ({
                           currentData,
                           refMaterial,
                           isSelectInEstimate,
                           selectInEstimate,
                           rowSelection,
                           setRowSelection,
                           selectMaterialId,
                           selectMaterial,
                           tableOptions,
                           tableOptionsHandle,
                           modal,
                           allMaterial,
                           enableRowSelection,
                           disabled,
                           settings,
                           selectMaterialIdByTree,
                           handleToggle,
                       }) => {

    const {onRowSelectionChange} = selectionTableUtil(currentData, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const columns = useMemo(
        () => [
            {
                header: 'Артикул',
                accessorKey: 'articleNumber',
                size: 170,
                Cell: ({cell}) => <CellShortenedName
                    value={cell.getValue()}
                    numberOfCharacters={20}
                />,
            },
            {
                header: 'Наименование',
                accessorKey: 'name',
                minSize: modal ? 520 : 600,
                Cell: ({cell, row}) => (refMaterial ?
                        <li key={cell.getValue()}>
                            <Link
                                to={allMaterial ? `/all-materials/${currentData[row.index].id}/${currentData[row.index].unit?.name}/${currentData[row.index].typeMaterial}${settings ? "?isSettings" : ""}` : '/organization/materials/' + currentData[row.index].id + '/' + currentData[row.index].unit?.name + '/' + currentData[row.index].typeMaterial + '/' + currentData[row.index].materialId}>
                                {cell.getValue()}</Link>
                        </li> : cell.getValue()
                ),
            },
            {
                header: 'Ед. изм.',
                accessorKey: 'unit.name',
                maxSize: 50,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ],
        [currentData, refMaterial],
    );

    return (
        <Box sx={{overflow: 'auto'}}>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                muiTablePaperProps={{
                    sx: disabled && {
                        opacity: 0.7
                    }
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',
                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        },
                        "&:first-of-type": enableRowSelection && {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem",
                        "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                            "minWidth": "100%"
                        }
                    },
                }}

                muiTableBodyRowProps={({row}) => {
                    return ({
                        onClick: () => {
                            if (!disabled && selectMaterial) {
                                selectMaterial(row.original)
                                handleToggle(row.original, false)
                            } else if (!disabled && handleToggle) {
                                handleToggle(row.original, false)
                            }
                        },
                        sx: () => ({
                            height: '36px',
                            cursor: "pointer",
                            "&:hover& td:after": (!modal || (disabled && modal) || row.original.id === selectMaterialId) && {
                                display: "none",
                            },
                            '&:nth-of-type(even)': {
                                backgroundColor: row.original.id === selectMaterialId || row.original.id === selectMaterialIdByTree ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    backgroundColor: row.original.id === selectMaterialId || row.original.id === selectMaterialIdByTree ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                            },
                            backgroundColor: row.original.id === selectMaterialId || row.original.id === selectMaterialIdByTree ? (theme) => theme.palette.primary.light : "white",
                            "&:hover": {
                                backgroundColor: row.original.id === selectMaterialId || row.original.id === selectMaterialIdByTree ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                        })
                    })
                }}
                displayColumnDefOptions={{
                    'mrt-row-select': {
                        size: "50px",
                        grow: false,
                    },
                }}
                getRowId={(originalRow) => originalRow.id}
                columns={columns}
                enableMultiRowSelection
                enableRowSelection={enableRowSelection}
                data={currentData}
                enableStickyHeader={true}
                enableStickyFooter={true}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: modal ? "435px" : settings && rowSelection.length > 0 ? `calc(100vh - 480px)` : settings ? `calc(100vh - 380px)` : `calc(100vh - 400px)`,
                        width: modal ? "770px" : settings ? "65vw" : "80vw"
                    }
                }}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                        "& .MuiStack-root": {
                            padding: 0,
                            "& .MuiBox-root": {
                                padding: "5px"
                            }
                        },

                    }
                }}
                manualSorting={true}
                localization={MRT_Localization_RU}
                renderRowActions={({row}) => (
                    <Box sx={{
                        display: 'flex',
                        gap: '0.1rem',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '50px'
                    }}>
                        {isSelectInEstimate && <Tooltip arrow placement="left" title="Заменить">
                            <Button size="small" sx={{minWidth: 'auto', marginLeft: 'auto'}} color="pencil"
                                    onClick={() => selectInEstimate(row)}>
                                <Cached sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                            </Button>
                        </Tooltip>}
                    </Box>
                )}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
                manualPagination={true}
                rowCount={tableOptions.totalElements}
                onRowSelectionChange={onRowSelectionChange}
                selectAllMode={'all'}
                state={{
                    globalFilter: tableOptions.searchData,
                    rowSelection: currentSelection,
                    columnVisibility: {
                        id: false,
                        "unit.name": !modal
                    },
                    pagination: tableOptions,
                    showGlobalFilter: true,
                }}

                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: modal ? "32px" : "5px",
                        paddingBottom: modal ? "32px" : "0px",
                        "& .MuiOutlinedInput-root": {
                            borderRadius: '12px',
                            border: '1 px solid red',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                enableToolbarInternalActions={false}
            />
        </Box>);
};

export default MaterialTable;
